import { ImageTransformOptions, ImageTransformType } from '@diritto/common/imageKit/constants';
import { ContentPublicRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { ProfileLitePublicRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import { ellipsis } from '@diritto/common/utils/string';
import { JsonLd } from 'app-components/common/JsonLd';
import { useMemo } from 'react';
import { configure } from 'utils/configure';
import { generateImageUrl } from 'utils/generateImageUrl';
import { getFullUrl } from 'utils/url';

export const ContentDetailJsonLd = ({
  content,
  authorProfile,
}: {
  content: ContentPublicRelayDto;
  authorProfile?: ProfileLitePublicRelayDto;
}) => {
  const openImageUrl = `${configure.dynamicCdnPublicUrl}/contents/og?url=${encodeURIComponent(
    generateImageUrl({
      path: content.cover.path,
      isPrivate: content.cover.isPrivate,
      transformation: ImageTransformOptions[ImageTransformType.OG],
    }),
  )}`;

  // 80 자를 넘으면 검색엔진에 반영이 잘 안된다.
  const description = useMemo(() => ellipsis(content?.description || '', 80), [content]);
  const url = useMemo(() => getFullUrl(`/contents/${content?.id}`), [content?.id]);
  const profileUrl = useMemo(
    () => (authorProfile ? getFullUrl(`/accounts/profiles/${authorProfile?.id}`) : ''),
    [authorProfile],
  );

  return (
    <JsonLd
      data={{
        '@context': 'http://schema.org',
        '@type': 'NewsArticle',
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': 'https://google.com/article',
        },
        headline: content.title,
        image: [openImageUrl],
        url,
        description,
        author: authorProfile
          ? {
              '@type': 'Person',
              name: authorProfile.nickname,
              url: profileUrl,
            }
          : undefined,
        datePublished: content.firstOpenedAt,
        dateModified: content.latestEpisodeOpenedAt || content.firstOpenedAt,
      }}
    />
  );
};
